export const MAPBOX_ACCESS_TOKEN =
    'pk.eyJ1Ijoibm9leGN1c2UiLCJhIjoiY2psY2RpdTd0MDJ6MzNxcGU1Y3d2ZWlxcCJ9.mzUWRAbKATTKBvGkQRf2WQ';
